import { useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import moment from 'moment';
import _, { isUndefined } from 'lodash';
import Text from '../../../../../components/Text';
import { ReactComponent as DiamondIcon } from '../../../../../static/images/DiamondIcon.svg';
import { ReactComponent as RunIcon } from '../../../../../static/images/RunIcon.svg';
import { ReactComponent as StandIcon } from '../../../../../static/images/StandIcon.svg';
import { DropDownIcon, DropUpIcon } from '../../../../../components/Icon';
import admissionUtil from '../../../../../utils/admissionUtil';
import StatusIcon from '../../../../BedStatus/newComponents/Icons/StatusBed';
import { conditional, initValue } from '../../../../../utils';

const useStyles = makeStyles((theme) => ({
  column: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: '6.75rem',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.75rem',
    color: '#7d86a9',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2.5rem',
    width: '100%',
  },
  finishBus: ({ color }) => ({
    borderRadius: '20px',
    border: `2px solid ${color}`,
    backgroundColor: '#FFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '1.5rem',
    zIndex: '100',
    position: 'relative',
  }),
  pendingBus: ({ color, bgcolor }) => ({
    borderRadius: '50%',
    width: '1.5rem',
    height: '1.5rem',
    border: `2px solid ${color}`,
    backgroundColor: bgcolor,
    zIndex: '100',
  }),
  step: ({ stepColor, stepIndex }) => ({
    position: 'absolute',
    left: '-100%',
    right: '50%',
    top: '50%',
    height: '2px',
    backgroundColor: stepColor,
    zIndex: 12 - stepIndex,
  }),
  time: {
    height: '2.1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'underline',
    textDecorationColor: '#7D86A9',
  },
  flag: {
    position: 'absolute',
    right: '-25%',
    top: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3rem',
    transform: 'translate(50%, calc(-0.7rem + 1px))',
    zIndex: '100',
  },
  diamondIcon: {
    width: '1.4rem',
    height: '1.4rem',
  },
  runIcon: {
    width: '2rem',
    height: '1.6rem',
  },
  remarkCard: {
    borderRadius: '4px',
    border: 'solid 1px #e4e7eb',
    padding: '0.313rem 0.313rem 0.313rem 0.563rem',
    backgroundColor: '#FFF',
    position: 'relative',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.25rem',
      height: '100%',
      backgroundColor: '#e4e7eb',
      zIndex: '9',
    },
  },
  remarkText: {
    color: '#2E4469',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
  },
  viewMoreBtn: {
    width: '9.875rem',
    height: '2rem',
    borderBottom: '1px solid #E4E7EB',
    borderLeft: '1px solid #E4E7EB',
    borderRight: '1px solid #E4E7EB',
    borderRadius: '0 0 4px 4px',
    color: '#7D86A9',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
  },
  dropIcon: {
    fontSize: '0.96rem',
    color: '#7D86A9',
    marginLeft: '0.63rem',
  },
}));

const BusStatus = ({ busTime, first, flag, color, bgcolor, stepColor, stepIndex, hold, showLine }) => {
  const classes = useStyles({ color, bgcolor, stepColor, stepIndex });

  return (
    <Box position="relative">
      {busTime ? (
        <Box className={classes.finishBus}>
          <Text color="#333" fontSize="0.75rem">
            {busTime}
          </Text>
        </Box>
      ) : (
        <Box display="flex" alignItems="flex-start" justifyContent="center">
          <div className={classes.pendingBus} />
        </Box>
      )}
      {!first && showLine && <div className={classes.step} />}
      {flag && (
        <Box className={classes.flag}>
          <DiamondIcon className={classes.diamondIcon} />
          {hold ? <StandIcon className={classes.runIcon} /> : <RunIcon className={classes.runIcon} />}
        </Box>
      )}
    </Box>
  );
};

const Card = ({ data, type, color, gender }) => {
  const classes = useStyles();

  if (_.isArray(data)) {
    if (type === 'ADM_DEC') {
      return (
        <Box display="flex" flexDirection="column" gridGap="0.56rem">
          {data.map((item, index) => (
            <Box
              display="flex"
              flexDirection="column"
              gridGap="0.25rem"
              key={item.txnAdmDecisionId ?? item.txnWardAckId ?? item.txnWardAssignId ?? item.txnWardReadyId}
            >
              {index > 0 && (
                <Box display="flex" justifyContent="center" mb="0.31rem">
                  <Box width="4px" height="4px" borderRadius="50%" bgcolor="#BABABA" />
                </Box>
              )}

              {index > 0 && (
                <Box borderRadius="20px" border={`2px solid ${color}`} bgcolor="#FFF" p="0.25rem">
                  <Text color="#333" fontSize="0.75rem" textAlign="center">
                    {conditional(item.actionDtm, moment(item.actionDtm).format(admissionUtil.busStopDateFormat), '')}
                  </Text>
                </Box>
              )}

              <Box borderRadius="12px" boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)" p="0.5rem" bgcolor="#FFF">
                {index === 0 && data.length > 1 && (
                  <Text color="#000" fontSize="0.75rem" textAlign="center">
                    {bustimeFormat(item?.actionDtm)}
                  </Text>
                )}
                <Text color="#000" fontSize="0.75rem" textAlign="center">
                  {`CORP/${initValue(item.actionBy, '')}`}
                </Text>
                <Box
                  borderRadius="8px"
                  border="2px solid #EFAA7E"
                  p="0.38rem"
                  bgcolor={index === 0 ? '#FBEADB' : '#EFAA7E'}
                  mt="0.37rem"
                >
                  <Text color="#000" fontSize="0.625rem" textAlign="center">
                    {index === 0 ? 'Assign to' : 'Change to'}
                  </Text>
                  <Text color="#000" fontSize="0.75rem" textAlign="center">
                    {`${initValue(item.specialtyCode, '')} ${initValue(item.subSpecialtyCode, '')}`}
                  </Text>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      );
    }

    if (type === 'WD_ASS') {
      return (
        <Box display="flex" flexDirection="column" gridGap="0.56rem">
          {data.map((item, index) => (
            <Box display="flex" flexDirection="column" gridGap="0.25rem" key={item.txnWardAssignId}>
              {index > 0 && (
                <Box display="flex" justifyContent="center" mb="0.31rem">
                  <Box width="4px" height="4px" borderRadius="50%" bgcolor="#BABABA" />
                </Box>
              )}

              {index > 0 && (
                <Box borderRadius="20px" border={`2px solid ${color}`} bgcolor="#FFF" p="0.25rem">
                  <Text color="#333" fontSize="0.75rem" textAlign="center">
                    {conditional(item.actionDtm, moment(item.actionDtm).format(admissionUtil.busStopDateFormat), '')}
                  </Text>
                </Box>
              )}

              <Box borderRadius="12px" boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)" p="0.5rem" bgcolor="#FFF">
                <Text color="#333" fontSize="0.625rem" textAlign="center">
                  {`${initValue(item.actionHospCd, '')} ${initValue(item.actionWardLoc, '')}`}
                </Text>
                <Text color="#000" fontSize="0.75rem" textAlign="center">
                  {`CORP/${initValue(item.actionBy, '')}`}
                </Text>
                <Box
                  borderRadius="8px"
                  border="2px solid #FECA06"
                  p="0.38rem"
                  bgcolor={index === 0 ? '#fff2c1' : '#FECA06'}
                  mt="0.37rem"
                >
                  <Text color="#000" fontSize="0.625rem" textAlign="center">
                    {item.actionType === 'R' ? 'Redirect to' : 'Assign to'}
                  </Text>
                  <Text color="#000" fontSize="0.75rem" textAlign="center">
                    {`${initValue(item.toHospCd, '')} ${initValue(item.toWardLoc, '')}`}
                  </Text>
                </Box>
              </Box>

              {item.remark && (
                <Box className={classes.remarkCard}>
                  <div className={classes.remarkText} title={item.remark}>
                    {item.remark}
                  </div>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      );
    }

    if (type === 'WD_ACK' || type === 'WD_RD') {
      return (
        <Box display="flex" flexDirection="column" gridGap="0.56rem">
          {data.map((item, index) => (
            <Box
              display="flex"
              flexDirection="column"
              gridGap="0.25rem"
              key={item.txnAdmDecisionId ?? item.txnWardAckId ?? item.txnWardAssignId ?? item.txnWardReadyId}
            >
              {index > 0 && (
                <Box display="flex" justifyContent="center" mb="0.31rem">
                  <Box width="4px" height="4px" borderRadius="50%" bgcolor="#BABABA" />
                </Box>
              )}

              {index > 0 && (
                <Box borderRadius="20px" border={`2px solid ${color}`} bgcolor="#FFF" p="0.25rem">
                  <Text color="#333" fontSize="0.75rem" textAlign="center">
                    {conditional(item.actionDtm, moment(item.actionDtm).format(admissionUtil.busStopDateFormat), '')}
                  </Text>
                </Box>
              )}

              <Box
                borderRadius="12px"
                boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)"
                p="0.5rem"
                bgcolor={item.redirectedWardAssignId ? 'rgb(190,190,190)' : '#538FFF'}
              >
                <Text color="#FFF" fontSize="1.3rem" textAlign="center">
                  {`${initValue(item.actionHospCd, '')} ${initValue(item.actionWardLoc, '')}`}
                </Text>
                <Text color="#FFF" fontSize="0.75rem" textAlign="center" wordBreak="break-word">
                  {`CORP/${initValue(item.actionBy, '')}`}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
      );
    }
    return <Box />;
  }

  if (type === 'AED_DC') {
    return (
      <Box borderRadius="12px" boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)" p="0.5rem" bgcolor="#FFF">
        <Text color="#000" fontSize="0.75rem" textAlign="center">
          {initValue(data.corp, '')}
        </Text>
        <Box borderRadius="8px" border="2px solid #92C951" p="0.38rem" bgcolor="#E4F1D3" mt="0.37rem">
          <Text color="#000" fontSize="0.625rem" textAlign="center">
            Discharge Dest.
          </Text>
          <Text color="#000" fontSize="0.75rem" textAlign="center">
            {initValue(data.dest, '')}
          </Text>
        </Box>
      </Box>
    );
  }

  if (type === 'ADM_REG') {
    return (
      <Box borderRadius="12px" boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)" p="0.5rem" bgcolor="#FFF">
        <Text color="#000" fontSize="0.75rem" textAlign="center">
          ADM. Officer
        </Text>
        <Box borderRadius="8px" border="2px solid #FECA06" p="0.38rem" bgcolor="#FFF2C1" mt="0.37rem">
          <Text color="#000" fontSize="0.625rem" textAlign="center">
            Assign to
          </Text>
          <Text color="#000" fontSize="0.75rem" textAlign="center">
            {initValue(data.title, '')}
          </Text>
          <Text color="#FF8181" fontSize="0.75rem" textAlign="center">
            {initValue(data.corp, '')}
          </Text>
        </Box>
      </Box>
    );
  }

  if (type === 'BED_ASS') {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="12px"
        boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)"
        p="0.5rem"
        bgcolor="#FFF"
      >
        <StatusIcon
          bedNo={initValue(data.bedNo, '')}
          ward={initValue(data.ward, '')}
          typeName={data.bedNo ? 'O' : 'TBC'}
          genderType={gender}
        />
      </Box>
    );
  }

  return (
    <Box borderRadius="12px" boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.25)" p="0.5rem" bgcolor="#538FFF">
      <Text color="#FFF" fontSize="0.625rem" textAlign="center">
        {initValue(data.title, '')}
      </Text>
      <Text color="#FFF" fontSize="0.75rem" textAlign="center" wordBreak="break-word">
        {initValue(data.corp, '')}
      </Text>
    </Box>
  );
};

const bustimeFormat = (time) => {
  return time ? moment(time).format(admissionUtil.busStopDateFormat) : null;
};

const initBusStopData = (data) => {
  const aedDc = data?.AED_DC;
  const busStopStep = data?.BUS_STOP_STEP;
  const busTime = aedDc ? bustimeFormat(aedDc.aedDischargedDtm) : null;
  // 决定bus stop到哪一步算是complete(显示绿色),可以在setting 的admission修改
  const completedStep = data?.COMPLETED === 'BED_ASS' ? 'BED_ASS' : 'AED_DC';
  const cardData = aedDc
    ? {
        corp: `CORP/${aedDc.aedDischargedBy}`,
        dest: aedDc.aedDischargedDest,
      }
    : null;

  const dcData = {
    title: 'AED discharged',
    color: '#FECA06',
    stepColor: '#FECA06',
    bgcolor: '#FFF2C1',
    busTime: busTime,
    currentTime: aedDc?.aedDischargedDtm,
    flag: busStopStep === 'AED_DC',
    cardData: cardData,
    type: 'AED_DC',
  };

  let tempData = [
    {
      title: 'Admission Decision',
      color: '#EFAA7E',
      stepColor: '#EFAA7E',
      bgcolor: '#FBEADB',
      busTime: bustimeFormat(data?.DEC_DTM),
      currentTime: data?.DEC_DTM,
      flag: data?.BUS_STOP_STEP === 'ADM_DEC',
      cardData: data?.ADM_DEC,
      type: 'ADM_DEC',
    },
    {
      title: 'Admission Ready',
      color: '#FECA06',
      stepColor: '#EFAA7E',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.ADM_RD?.admReadyDtm),
      currentTime: data?.ADM_RD?.admReadyDtm,
      flag: data?.BUS_STOP_STEP === 'ADM_RD',
      cardData: data?.ADM_RD
        ? {
            title: `${data?.ADM_RD?.admReadyHospCode} ${data?.ADM_RD?.admReadyWardName}`,
            corp: `CORP/${data?.ADM_RD?.admReadyBy}`,
          }
        : null,
      type: 'ADM_RD',
      hide: isUndefined(data?.ADM_RD),
    },
    {
      title: data?.WARD_ASSIGN_TITLE,
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.WD_ASS?.[0]?.actionDtm),
      currentTime: data?.WD_ASS?.[0]?.actionDtm,
      flag: data?.BUS_STOP_STEP === 'WD_ASS',
      cardData: data?.WD_ASS,
      type: 'WD_ASS',
      hide: isUndefined(data?.WD_ASS),
    },
    {
      title: 'Ward Acknowledged',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.WD_ACK?.[0]?.actionDtm),
      currentTime: data?.WD_ACK?.[0]?.actionDtm,
      flag: data?.BUS_STOP_STEP === 'WD_ACK',
      cardData: data?.WD_ACK,
      type: 'WD_ACK',
      hide: isUndefined(data?.WD_ACK),
    },
    {
      title: 'Ward Ready',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.WD_RD?.[0]?.actionDtm),
      currentTime: data?.WD_RD?.[0]?.actionDtm,
      flag: data?.BUS_STOP_STEP === 'WD_RD',
      cardData: data?.WD_RD,
      type: 'WD_RD',
      hide: isUndefined(data?.WD_RD),
    },
    {
      title: 'Admission Registration',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.ADM_REG?.admRegDtm),
      currentTime: data?.ADM_REG?.admRegDtm,
      flag: data?.BUS_STOP_STEP === 'ADM_REG',
      cardData: data?.ADM_REG
        ? {
            title: `${data?.ADM_REG?.admRegHospCd} ${data?.ADM_REG?.admRegWardLoc}`,
            corp: data?.ADM_REG?.admRegHn,
          }
        : null,
      type: 'ADM_REG',
    },
    {
      title: 'Porter dispatch',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.PORTER),
      currentTime: data?.PORTER,
      flag: data?.BUS_STOP_STEP === 'PORTER',
      cardData: null,
      type: 'PORTER',
      hide: isUndefined(data?.PORTER),
    },
    {
      title: 'Ward Arrival',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.WD_ARR),
      currentTime: data?.WD_ARR,
      flag: data?.BUS_STOP_STEP === 'WD_ARR',
      cardData: null,
      type: 'WD_ARR',
      hide: isUndefined(data?.WD_ARR),
    },
    {
      title: 'Bed Assigned',
      color: '#FECA06',
      stepColor: '#FECA06',
      bgcolor: '#FFF2C1',
      busTime: bustimeFormat(data?.BED_ASS?.bedAssignedDtm),
      currentTime: data?.BED_ASS?.bedAssignedDtm,
      cardData: data?.BED_ASS
        ? {
            bedNo: data?.BED_ASS?.bedAssignedBedNo,
            ward: data?.BED_ASS?.bedAssignedWardCd,
          }
        : null,
      type: 'BED_ASS',
    },
  ];

  const INSERT_POSITIONS = {
    APD: 7,
    AAR: 6,
    AWR: 5,
  };

  const COMPLETED_STYLE = {
    stepColor: '#92C951',
    color: '#92C951',
    bgcolor: '#E4F1D3',
  };

  function insertDcData(tempData, dcData, insertPosition) {
    tempData.splice(insertPosition, 0, dcData);
    return tempData;
  }

  // reorder AED_DC
  switch (data?.AED_DISCHG_POSITION) {
    case 'APD':
      // AED_DC站点显示在 PORTER 后面
      tempData = insertDcData(tempData, dcData, INSERT_POSITIONS.APD);
      break;
    case 'AAR':
      // AED_DC站点显示在 ADM_REG后面
      tempData = insertDcData(tempData, dcData, INSERT_POSITIONS.AAR);
      break;
    case 'AWR':
      // AED_DC站点显示在WD_RD后面
      tempData = insertDcData(tempData, dcData, INSERT_POSITIONS.AWR);
      break;

    default:
      break;
  }

  const completedStepIndex = _.findIndex(tempData, (item) => item.type === completedStep);
  tempData = _.map(tempData, (item, index) => {
    if (item.type === 'ADM_DEC' || completedStepIndex === -1 || index < completedStepIndex) {
      return item;
    }

    return {
      ...item,
      ...COMPLETED_STYLE,
    };
  });

  // hide bus stop
  tempData = _.filter(tempData, (item) => !item.hide);

  // buffer time
  tempData = _.map(tempData, (item, index) => ({
    ...item,
    time: admissionUtil.mathBuffTime(item.currentTime, tempData[index - 1]?.currentTime),
  }));

  return tempData;
};

const BusStopUI = ({
  bgcolor = '#F5FAFF',
  p = '1.2rem 1.5rem',
  m = '0 0 1.25rem',
  title = true,
  editView = false,
  data,
  hold,
  gender,
}) => {
  const classes = useStyles();
  const [viewMore, setViewMore] = useState(editView ? false : true);

  const busStopData = initBusStopData(data);

  const handleViewMore = () => {
    setViewMore((preData) => !preData);
  };

  return (
    <Box display="flex" flexDirection="column" m={m}>
      <Box
        display="flex"
        borderRadius="8px"
        bgcolor={bgcolor}
        p={p}
        gridGap="0.81rem"
        border={editView ? '1px solid #E4E7EB' : 'none'}
        overflow="auto"
      >
        {busStopData.map((item, index) => (
          <Box className={classes.column} key={item.title}>
            {title && <div className={classes.title}>{item.title}</div>}
            <BusStatus
              {...item}
              first={index === 0}
              stepIndex={index}
              hold={hold}
              showLine={data?.IS_BUS_STOP_LINE_REQ === 'Y'}
            />
            <div className={classes.time}>
              <Text fontSize="0.75rem">{item.time}</Text>
            </div>
            {viewMore && item.cardData && (
              <Card data={item.cardData} type={item.type} color={item.color} gender={gender} />
            )}
          </Box>
        ))}
      </Box>
      {editView && (
        <Box display="flex" justifyContent="flex-end">
          <ButtonBase className={classes.viewMoreBtn} onClick={handleViewMore}>
            View More
            {viewMore ? <DropUpIcon className={classes.dropIcon} /> : <DropDownIcon className={classes.dropIcon} />}
          </ButtonBase>
        </Box>
      )}
    </Box>
  );
};

export default BusStopUI;
